// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { LMToolbarServiceBase } from '@toolbar/lm-toolbar-service.base';
import { LMToolbarServiceAdapter } from '@toolbar/lm-toolbar-service-adapter';

@Injectable()
export class LMSuiteHomeToolbarService extends LMToolbarServiceBase {
  constructor(public lmToolbarServiceAdapter: LMToolbarServiceAdapter) {
    super(lmToolbarServiceAdapter); // must msg the base class constructor
  }

  public buildToolbar(): void {
    const actionRefArray: Array<LMBusActionReference> = [];

    this.toolbarButtons = this.createToolbarMenuItemsFromActionReferences(null, actionRefArray);
    this.fireToolbarObservable();
  }
}
